export default __webpack_public_path__ + "static/media/picThaoNguyen.3f0d7112.png";